import Const from 'constants';

let PlayersLock = {
    setLockedPlayersFromStorage(items) {
        return (dispatch) => {
            dispatch(this.setLockedPlayers(items, {saveToStorage: false}));
        };
    },

    setLockedPlayers(items, options = {}) {
        return (dispatch) => {
            const {countPlayers = true, saveToStorage = true} = options;

            dispatch({
                type: Const.LOCKING_SET_PLAYERS,
                items,
            });

            countPlayers && dispatch(this.setPlayersCounters());

            saveToStorage && dispatch(
                this.saveDataToStorage('filterLocked', (state) => {
                    const {playersLock} = state;
                    return playersLock.all();
                }),
            );
        };
    },
};

export default PlayersLock;
